export default "__VITE_ASSET__Dj0Ia4PL__"